// extracted by mini-css-extract-plugin
export default {"ImpactLayer__accordion_container":"ImpactLayer_ImpactLayer__accordion_container__cCTa-"};